import React, {Fragment} from "react";
import landmark from "../../assets/imgs/landmark.svg";
import delivery from "../../network/models/quick_models";
import formatter from "../../helpers/number_formatter";


const DashboardDeliveryQuote = ({change}) => {

    //Merged models
    let partialDeliveryOrder = {...delivery.createDeliveryOrderResponse, ...change.current.deliveryOrder};
    return (
        <>
            <div className="delivery-quote-card">
                <div className="container">
                    <ul className="list-unstyled">
                        <li>
                            <div className="row justify-content-center no-gutters">
                                <div className="col-1 text-right">
                                    <img src={landmark} className="img-fluid" style={{
                                        textAlign: "right",
                                        height: 34, marginTop: 21, marginRight: 7
                                    }}/>
                                </div>
                                <div className="col-11 text-left">
                                    <ul className="list-unstyled dropoff-pickup-alt">
                                        <li><p style={{margin: 0, padding: 0, fontSize: 11}}>
                                            {partialDeliveryOrder.pick_up.address}
                                        </p></li>
                                        <li><p style={{margin: 0, padding: 0, fontSize: 11}}>
                                            {partialDeliveryOrder.drop_off.address}
                                        </p></li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li style={{marginTop: 25, marginLeft: 9, marginBottom: 15}}>
                            <h5 style={{color: "#FFF"}}>GH{formatter.accounting.formatMoney(partialDeliveryOrder.quote.fee, "¢ ")}</h5>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="delivery-quote-card-bottom">
                <ul className="list-unstyled">
                    <li>
                        <p>Package content</p>
                    </li>
                    <li>
                        <hr/>
                    </li>
                    {partialDeliveryOrder.manifest.map((items, index) => {
                        return (
                            items.size === 0 ? null :<Fragment key={index}>
                            <li><p>{items.name} (x{items.quantity})</p></li>
                        </Fragment>
                        );
                    })}
                </ul>
            </div>
        </>
    );
};

export default DashboardDeliveryQuote;
